export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes5_sell.a54d47ca.mp3";